export function getSessionOptions(): string[] {
    const year = new Date().getFullYear();
    return [
        `${year - 1}-${year}`,
        `${year}-${year + 1}`,
        `${year + 1}-${year + 2}`,
    ];
}

export function getDefaultSession(): string {
    const year = new Date().getFullYear();
    return `${year}-${year + 1}`;
}

export const termOptions = ["1st Term", "2nd Term", "3rd Term", "4th Term"];

/** Suggest the next school year from a current session name (matches onboarding hyphen style). */
export function suggestNextSessionName(current: string): string {
    const match = current.match(/(\d{4})\s*[\/\-]\s*(\d{2,4})/);
    if (match) {
        const start = Number(match[1]);
        const endRaw = match[2];
        const end = endRaw.length === 2 ? 2000 + Number(endRaw) : Number(endRaw);
        return `${start + 1}-${end + 1}`;
    }
    const year = current.match(/\b(20\d{2})\b/);
    if (year) {
        const y = Number(year[1]);
        return `${y + 1}-${y + 2}`;
    }
    return getDefaultSession();
}

/** Merge onboarding year options with a suggested next session. */
export function buildSessionDropdownOptions(currentSessionName?: string): string[] {
    const suggested = currentSessionName ? suggestNextSessionName(currentSessionName) : getDefaultSession();
    const seen = new Set<string>();
    const out: string[] = [];
    for (const name of [suggested, ...getSessionOptions(), currentSessionName].filter(Boolean) as string[]) {
        const key = name.trim().toLowerCase();
        if (!key || seen.has(key)) continue;
        seen.add(key);
        out.push(name.trim());
    }
    return out;
}

/** Standard term labels plus previous terms used at this school. */
export function buildTermDropdownOptions(previousTermNames: string[] = []): string[] {
    const seen = new Set<string>();
    const out: string[] = [];
    for (const name of [...termOptions, ...previousTermNames]) {
        const trimmed = (name || '').trim();
        const key = trimmed.toLowerCase();
        if (!key || seen.has(key)) continue;
        seen.add(key);
        out.push(trimmed);
    }
    return out;
}

export function suggestNextTermName(
    currentTermName?: string | null,
    previousTermNames: string[] = [],
): string {
    const current = (currentTermName || '').trim();
    const idx = termOptions.findIndex((t) => t.toLowerCase() === current.toLowerCase());
    if (idx >= 0 && idx < termOptions.length - 1) {
        return termOptions[idx + 1];
    }
    const used = new Set(
        [...previousTermNames, current]
            .map((t) => t.trim().toLowerCase())
            .filter(Boolean),
    );
    return termOptions.find((t) => !used.has(t.toLowerCase())) ?? termOptions[0];
}
